export const defaultDetailPaneSize = '30%';
export const emailDomain = 'aloft.ai';
export const baseUrl = `https://www.${emailDomain}`;
export const appTimeout = 10000;
